import { Buffer } from 'buffer';
import { shareTokenPayloadSchema, ShareTokenPayload } from './types';

export function decodeShareTokenPayloadUnsafe(token: string): ShareTokenPayload | null {
  const parts = token.split('.');
  if (parts.length !== 3) {
    return null;
  }
  const [, payload] = parts;
  if (payload === undefined) {
    return null;
  }
  try {
    const json = Buffer.from(payload, 'base64').toString('utf8');
    const raw: unknown = JSON.parse(json);
    const parsed = shareTokenPayloadSchema.safeParse(raw);
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}
